import { render, staticRenderFns } from "./CustomerInputStatistics.vue?vue&type=template&id=af2e4d28"
import script from "./CustomerInputStatistics.vue?vue&type=script&lang=ts"
export * from "./CustomerInputStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports